import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import LoginPage from "@/pages/LoginPage";
import HubPage from "@/pages/HubPage";
import SsoPage from "@/pages/SsoPage";
import DashboardPage from "@/pages/DashboardPage";
import LabelsPage from "@/pages/LabelsPage";
import PlatformPage from "@/pages/PlatformPage";
import MappingsPage from "@/pages/MappingsPage";
import PicklistPage from "@/pages/PicklistPage";
import BatchesPage from "@/pages/BatchesPage";
import SettingsPage from "@/pages/SettingsPage";
import ScanPage from "@/pages/ScanPage";

const Protected = ({ children, adminOnly = false }) => {
  const { user } = useAuth();
  if (user === null) return <div className="flex min-h-screen items-center justify-center font-mono text-xs uppercase tracking-widest text-slate-400" data-testid="auth-loading">Checking session…</div>;
  if (user === false) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
};

const PublicOnly = ({ children }) => {
  const { user } = useAuth();
  if (user) return <Navigate to="/" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<PublicOnly><LoginPage /></PublicOnly>} />
          <Route path="/sso" element={<SsoPage />} />
          <Route path="/" element={<Protected><HubPage /></Protected>} />
          <Route element={<Protected><Layout /></Protected>}>
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/labels" element={<LabelsPage />} />
            <Route path="/platform" element={<PlatformPage />} />
            <Route path="/scan" element={<ScanPage />} />
            <Route path="/picklist" element={<PicklistPage />} />
            <Route path="/mappings" element={<MappingsPage />} />
            <Route path="/batches" element={<BatchesPage />} />
            <Route path="/settings" element={<Protected adminOnly><SettingsPage /></Protected>} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
